import React from 'react'
const ScreenContext = React.createContext('lg')
export const ScreenProvider = ScreenContext.Provider
export default ScreenContext